import { render, staticRenderFns } from "./ChatHeader.vue?vue&type=template&id=521fe271&scoped=true"
import script from "./ChatHeader.vue?vue&type=script&lang=js"
export * from "./ChatHeader.vue?vue&type=script&lang=js"
import style0 from "./ChatHeader.vue?vue&type=style&index=0&id=521fe271&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521fe271",
  null
  
)

export default component.exports